module.exports = __webpack_public_path__ + "static/22-cacec31b3d5182a73415d05ff66f736c.png";